import React, { useEffect, useRef, useState } from "react";
import { List as DhxList } from "dhx-suite";
import { SnippetListItem } from "../../models";

const listConfig: { [key: string]: any } = {
    selection: false,
    template: (item: SnippetListItem) =>
        `<span>${item.widgetName ? `<b>${item.widgetName}.</b> ` : ""}${item.title}</span>`
};

interface SearchListProps {
    snippetsList: SnippetListItem[];
    onSelect: (id: string) => void;
}

export const SearchList = ({ snippetsList, onSelect }: SearchListProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [list, setList] = useState<DhxList<SnippetListItem>>();

    useEffect(() => {
        if (!list && ref.current) {
            const newList = new DhxList<SnippetListItem>(ref.current, listConfig);
            setList(newList);
        }
        if (list) {
            list.events.on("click", onSelect);
            return () => list.events.detach("click");
        }
        return undefined;
    });

    useEffect(() => {
        if (list) {
            list.data.removeAll();
            list.data.parse(snippetsList.map(i => ({ ...i, id: i.url })));
        }
    }, [snippetsList]);

    return <div className="st-search-list" ref={ref}></div>;
};
